import { React, useState } from 'react';
import { showToast } from '../../../Utils';
import { apiCall } from '../../../api/Interactor';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAppState } from '../../../AppStateContext';

export default function Login() {
    const { updateUser } = useAppState();
    const navigate = useNavigate();

    let [email, setEmail] = useState("");
    let [password, setPassword] = useState("");

    const callPostLogin = () => {
        apiCall(
            "POST", process.env.REACT_APP_USER_LOGIN,
            {
                "email": email,
                "password": password
            },
            (response) => {
                console.log(response)
                showToast("Success", "Success", response.data.meta.message)
                setTimeout(() => {
                    console.log(response.data.data);
                    updateUser(response.data.data);
                    navigate('/');
                }, 2000)
            },
            (message) => {
                showToast("Error", "Failed", message)
            }
        )
    }

    return (
        <main className="flex-1 flex-col px-10 py-12">
            <div className="flex flex-col text-gray-600 space-y-5">
                <div className="text-center pb-4">
                    <img src="/logo_fityuk.webp" width={240} className="mx-auto" />
                    <div className="mt-8">
                        <h3 className="text-gray-800 text-xl font-semibold">Login to your account</h3>
                    </div>
                </div>
                <form
                    onSubmit={(e) => {
                        e.preventDefault();
                        callPostLogin();
                    }}
                    className="space-y-5"
                >
                    <div>
                        <label className="font-medium">
                            Email
                        </label>
                        <input
                            onChange={(e) => { setEmail(e.target.value) }}
                            value={email}
                            type="email"
                            required
                            className="w-full mt-2 px-3 py-2 text-gray-500 bg-transparent outline-none border focus:border-indigo-600 shadow-sm rounded-lg"
                        />
                    </div>
                    <div>
                        <label className="font-medium">
                            Password
                        </label>
                        <input
                            type="password"
                            onChange={(e) => { setPassword(e.target.value) }}
                            value={password}
                            required
                            className="w-full mt-2 px-3 py-2 text-gray-500 bg-transparent outline-none border focus:border-indigo-600 shadow-sm rounded-lg"
                        />
                    </div>
                    <div className="flex items-center justify-between text-sm">
                        <div className="flex items-center gap-x-3">
                            <input type="checkbox" id="remember-me-checkbox" className="checkbox-item peer hidden" />
                            <label
                                htmlFor="remember-me-checkbox"
                                className="relative flex w-5 h-5 bg-white peer-checked:bg-indigo-600 rounded-md border ring-offset-2 ring-indigo-600 duration-150 peer-active:ring cursor-pointer after:absolute after:inset-x-0 after:top-[3px] after:m-auto after:w-1.5 after:h-2.5 after:border-r-2 after:border-b-2 after:border-white after:rotate-45"
                            >
                            </label>
                            <span>Remember me</span>
                        </div>
                        <NavLink
                            to="/forgot_password"
                            className="text-center text-indigo-600 hover:text-indigo-500">
                            Forgot password?
                        </NavLink>
                    </div>
                    <div></div>
                    <button
                        className="w-full px-4 py-2 text-white font-medium bg-indigo-600 hover:bg-indigo-500 active:bg-indigo-600 rounded-lg duration-150"
                    >
                        Login
                    </button>
                </form>
                <div></div>
                <p className="text-center">Don't have an account? <NavLink
                    to="/registration"
                    className="font-medium text-indigo-600 hover:text-indigo-500">
                    Registration
                </NavLink></p>
            </div>
        </main>
    );
}